import React, { useMemo } from 'react';
import { PolicyOverdueDebtDetail, PolicyOverdueDebtHeaders, PolicyOverdueDebtTotalsByBadge } from '../../../../../shared/interfaces/services/policy-overdue-debt-service';
import { CardRender } from '../../../../../shared/components/CardRender';
import { renderCurrency } from '../../../../../shared/utils';

interface PolicyOverdueDebtTotalsCardProps {
    total: PolicyOverdueDebtTotalsByBadge;
    headers: PolicyOverdueDebtHeaders;
    loading?: boolean;
    key: string;
}



const PolicyOverdueDebtTotalsCard: React.FC<PolicyOverdueDebtTotalsCardProps> = ({ total, loading, headers }) => {
    const {
        deudaMasDe90Dias,
        deudaHasta90Dias,
        deudaHasta60Dias,
        deudaHasta30Dias,
        deudaPorVencer
    } = total;
    
    const columnsDataDebt = useMemo(() => [
        {
            label: `Deuda anterior`,
            value: renderCurrency(deudaMasDe90Dias),
        },
        {
            label: `Hasta ${headers.firstColumn}`,
            value: renderCurrency(deudaHasta90Dias),
        },
        {
            label: `Hasta ${headers.secondColumn}`,
            value: renderCurrency(deudaHasta60Dias),
        },
        {
            label: `Hasta ${headers.thirdColumn}`,
            value: renderCurrency(deudaHasta30Dias),
        },
        {
            label: 'Deuda por Vencer',
            value: renderCurrency(deudaPorVencer),
        },
    ], [
        deudaMasDe90Dias,
        deudaHasta90Dias,
        deudaHasta60Dias,
        deudaHasta30Dias,
        deudaPorVencer,
        headers
    ]);
    

    return (
        <CardRender
            title={''}
            article={undefined}
            tags={undefined}
            actions={undefined}
            loading={loading}
            columnsData={columnsDataDebt}
        />
    );
};

export default PolicyOverdueDebtTotalsCard;